export default __webpack_public_path__ + "static/media/16.ed4271cc.mp3";